import { createApp } from 'vue'
import "@/assets/styles/common.less";
import "@/assets/styles/element.less";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from "./router";
import i18n from "@/lang/index";
import "@/assets/styles/global.less";
import store from '@/store';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import emitt from '@/until/emitt';
import component from "@/components";


const app = createApp(App)

app.use(VueViewer)
app.use(ElementPlus)
app.use(router)
app.use(component)
app.use(i18n)
app.use(store)
app.mount('#app')
app.provide('emitt', emitt);


import { debounce } from "lodash";
const resizeObserver  = (window).ResizeObserver;
(window).ResizeObserver = class ResizeObserver extends resizeObserver  {
  constructor(callback) {
    callback = debounce(callback, 100);
    super(callback);
  }
};